import { render, staticRenderFns } from "./ContentWithSidebar.vue?vue&type=template&id=299c1c99&"
import script from "./ContentWithSidebar.vue?vue&type=script&lang=js&"
export * from "./ContentWithSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ContentWithSidebar.vue?vue&type=style&index=0&id=299c1c99&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('299c1c99')) {
      api.createRecord('299c1c99', component.options)
    } else {
      api.reload('299c1c99', component.options)
    }
    module.hot.accept("./ContentWithSidebar.vue?vue&type=template&id=299c1c99&", function () {
      api.rerender('299c1c99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue"
export default component.exports